import $ from 'jquery';
// import MyModule from '3.modules/MyModule';
// import {$body, $html} from '4.plugins/Globals/Globals';
import objectFitImages from 'object-fit-images';
import autosize from 'autosize';
import TitleDeco from '3.modules/titleDeco/TitleDeco';
import PageHeader from '3.modules/pageHeader/PageHeader';
require('9.vendors/jvfloat');
require('masonry-layout/dist/masonry.pkgd');

export default class Main {
  constructor() {
    // IE polyfill for object-fit: cover.
    objectFitImages();

    this.initFloatLabels();
    $('textarea').attr('rows', 1);
    autosize($('textarea'));

    // set services module grid.
    this.initServicesGrid();

    new TitleDeco($('body'));
    new PageHeader();
  }

  initServicesGrid() {
    // Add "utility" columns and gutters.
    const $container = $('.service__list--desktop');
    $container.append('<div class="service__column-helper" />');
    $container.append('<div class="service__gutter-helper" />');
    $('.service__list--desktop').masonry({
      itemSelector: '.service__item',
      columnWidth: '.service__column-helper',
      gutter: '.service__gutter-helper',
      transitionDuration: 0
    });
  }

  initFloatLabels() {
    const $inputs = $('.gfield--text, .gfield--textarea, .gfield--email, .gfield--number, .gfield--website, .gfield--phone, .gfield--name .ginput_complex > span, .gfield--address .ginput_complex > span, .gfield--time .clear-multi > div, .login-username, .login-password');
    $inputs.each((i, el) => {
      const $el = $(el);
      $el.find('input, textarea').attr('placeholder', $el.find('label').text());
    });
    $inputs.find('input, textarea').jvFloat();
    $inputs.find('.placeHolder').each((i, el) => {
      // Wrap the last * in a <span class="gfield_required">
      const txt = $(el).text();
      //$(el).html(txt.replace(/\*$/, '<span class="gfield_required">*</span>'));
      $(el).html(txt.replace(/\*$/, ''));
    });
  }
}



// WEBPACK FOOTER //
// ./site.js